import {
  project1,
  project1Home,
  project2,
  Project2Home,
  project3,
  project3Home,
  project4
} from "./projectImages";

export const projectData = [
  {
    id: 1,
    image: project1,
    transitionImage: project1Home,
    title: "An ecommerce app for frames",
    codeLink: "https://github.com/rushit163/frames-ecommerce",
    liveLink: "",
  },
  {
    id: 2,
    image: project2,
    transitionImage: Project2Home,
    title: "Ecommerce with next.js",
    codeLink: "https://github.com/rushit163/Ecommerce",
    liveLink: "",
  },
  {
    id: 3,
    image: project3,
    transitionImage: project3Home,
    title: "Networking Nexus Student club",
    codeLink: "https://github.com/net-nex/Main-Website",
    liveLink: "https://www.netnexsrm.com/",
  },
  {
    id: 4,
    image: project4,
    transitionImage: project4,
    title: "Social Media App",
    codeLink: "",
    liveLink: "",
  },
  
];
